/*
  Pflanzenkarte mit Topfwahl (Kollektionsseiten; alle Produktkarten,
  geladen ueber sections/header.liquid).
  ==============================================================
  Erweitert vorhandene Produktkarten (.ProductItem), egal ob sie aus Liquid
  (snippets/product-item.liquid) oder aus Boost (assets/boost-pfs-filter.js) stammen.
  Am bestehenden Karten-Markup wird nichts umgebaut - das Skript legt nur Elemente dazu
  und blendet per Klasse am .ProductItem aus. Faellt etwas aus (Daten fehlen, Fehler),
  bleibt die Karte genau wie bisher.

  Ablauf je Karte:
    1. Nur Pflanzen: Karte enthaelt [data-plant-size-meta] (Ø/Hoehe-Chips).
    2. /products/<handle>?view=fgkarte  (templates/product.fgkarte.liquid): Konfigurator aktiv?
       Konfigurator-Bild, Groesse (oe), Pflanzenpreis.
    3. /collections/konfigurator-oe-<oe>?view=fgtopf (templates/collection.fgtopf.liquid):
       passende Toepfe nach derselben Regel wie der Konfigurator (konfigurator_size_key).
    4. Erstes Bild = Pflanze im Topf (Konfigurator-Bilder), darunter die Topfwahl,
       eine kompakte Zeile "Ø · Höhe · ★" statt Chips + Sternezeile (Variante 2), unter dem
       Preis "+ Topf X 24,90 € · zusammen 46,80 €" (Option A).
    5. Nach einer Topfwahl bekommen die Links der Karte ?fgtopf=<Varianten-ID>; die
       Produktseite waehlt den Topf dann vor (snippets/fg-topf-vorauswahl.liquid).

  Pflanzen-Sets (custom.set_bestandteile, Daten "set" aus product.fgkarte): jede Pflanze steht in
  ihrem eigenen Topf nebeneinander, nach custom.pflanzenhoehe zueinander skaliert, die mittlere vorn
  (wie die Set-Vorschau auf der Produktseite, snippets/product-livepreview.liquid). Sets haben keine
  Ø/Hoehe-Chips - erkannt werden sie am Titel oder Handle ("Set", "Trio", "Duo").
  Topfzeile beim Set: "+ 3 × Topf X je 24,90 € · zusammen ..." (je Pflanze ein Topf, wie im Konfigurator).

  Notbremse: window.FG_PFLANZKARTE_AUS = true (z. B. per Theme-Editor-Skript) schaltet ab.
*/
(function () {
  'use strict';
  if (window.__fgPflanzkarte || window.FG_PFLANZKARTE_AUS) return;
  window.__fgPflanzkarte = true;
  /* Kein Aufblitzen des Freistellers: Pflanzenkarten zeigen bis zur Entscheidung einen grauen
     Platzhalter (CSS .fgk-js). Karten ohne Konfigurator bekommen .fgk-aus und zeigen ihr Bild wie
     bisher - spaetestens nach WARTEN ms, auch wenn Daten oder Bilder haengen. */
  var WARTEN = 3000;
  document.documentElement.classList.add('fgk-js');
  /* alte Zwischenspeicher-Eintraege frueherer Versionen (fgk:, fgk2:, fgk3:) entfernen */
  try {
    for (var si = sessionStorage.length - 1; si >= 0; si--) {
      var sn = sessionStorage.key(si); if (sn && /^fgk[23]?:/.test(sn)) sessionStorage.removeItem(sn);
    }
  } catch (e) {}

  var MAX_DESKTOP = 6, MAX_MOBIL = 4;
  var POT_TOP = 0.5731;          /* Topfbild beginnt bei 745/1300 der Buehne (wie Konfigurator: -9 % Ueberlappung) */
  var BUEHNE_H = 1.3;            /* Buehne = 1000 x 1300 Einheiten */
  var POT_UNTEN = 1110;          /* sichtbare Unterkante Topf + Schatten in Buehnen-Einheiten */

  var SET_RE = /(^|[^a-zäöü])set|set($|[^a-zäöü])|\btrio\b|\bduo\b/i;   /* "Pflanzen-Set", "4er-pflanzenset", "Trio" - nicht "Untersetzer" */
  var cacheP = {}, cacheT = {}, SPEICHER_MS = 30 * 60 * 1000;
  function holeJSON(url, cache, key) {
    if (cache[key]) return cache[key];
    var sk = 'fgk6:' + key;   /* 6 = (Badge Kunstpflanze); 5 = Ueberhang je Set-Pflanze (hg); 3 = (Badges); Eintraege gelten 30 Minuten, damit neue Daten
                                 (z. B. Bestseller, Preise) ohne neuen Tab ankommen */
    try {
      var s = sessionStorage.getItem(sk), e = s && JSON.parse(s);
      if (e && e.t && Date.now() - e.t < SPEICHER_MS) { cache[key] = Promise.resolve(e.d); return cache[key]; }
    } catch (x) {}
    cache[key] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status); return r.text();
    }).then(function (t) {
      var j = JSON.parse(t);
      try { sessionStorage.setItem(sk, JSON.stringify({ t: Date.now(), d: j })); } catch (e) {}
      return j;
    });
    return cache[key];
  }

  function geld(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* "Übertopf Patt Grau aus glasfaserverstärktem Ton" -> "Patt Grau",
     "Blumentopf Patt Grau aus Ton, mit hohen Füßen" -> "Patt Grau mit hohen Füßen" */
  function kurzname(t) {
    var s = t.t || '', zusatz = '';
    if (!s) return t.n || '';
    var k = s.indexOf(', '); if (k > -1) { zusatz = ' ' + s.slice(k + 2); s = s.slice(0, k); }
    s = s.replace(/^(Eckiger\s+|Runder\s+|Großer\s+)?(Übertopf|Blumentopf|Pflanzkübel|Pflanzkorb|Pflanzschale|Pflanzgefäß|Bodenvase|Pflanztopf|Topf)\s+/i, '');
    s = s.split(/\s+(aus|in|von)\s+/)[0];
    return (s + zusatz).trim();
  }

  /* Shopify-Bild in passender Breite laden (JSON liefert 800 px): kleine Karten (mobil) laden
     weniger und sind schneller fertig */
  function passendeBreite(url, box, faktor) {
    if (!url) return url;
    var px = (box.clientWidth || 400) * (window.devicePixelRatio || 1) * (faktor || 1.15), w = 800;
    [400, 500, 600].some(function (x) { if (px <= x) { w = x; return true; } });
    if (w >= 800) return url;
    return url.replace(/_800x(\.[a-z]+\?)/i, '_' + w + 'x$1').replace(/([?&]width=)800\b/, '$1' + w);
  }

  function handleVon(item) {
    var a = item.querySelector('a.ProductItem__ImageWrapper') || item.querySelector('.ProductItem__Title a');
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  /* Oberste und unterste deckende Zeile des Pflanzenbilds (0..1), wie im Set-Skript der Produktseite */
  function rand(img) {
    var r = { o: 0.1, u: 1, l: 0, r: 1 };
    try {
      var w = 120, h = Math.max(1, Math.round(img.naturalHeight * w / img.naturalWidth)), c = document.createElement('canvas');
      c.width = w; c.height = h; var x = c.getContext('2d'); x.drawImage(img, 0, 0, w, h);
      var d = x.getImageData(0, 0, w, h).data, y, i, f;
      for (y = 0, f = false; y < h && !f; y++) for (i = 0; i < w; i++) if (d[(y * w + i) * 4 + 3] > 40) { r.o = y / h; f = true; break; }
      for (y = h - 1, f = false; y >= 0 && !f; y--) for (i = 0; i < w; i++) if (d[(y * w + i) * 4 + 3] > 40) { r.u = (y + 1) / h; f = true; break; }
      for (i = 0, f = false; i < w && !f; i++) for (y = 0; y < h; y++) if (d[(y * w + i) * 4 + 3] > 40) { r.l = i / w; f = true; break; }
      for (i = w - 1, f = false; i >= 0 && !f; i--) for (y = 0; y < h; y++) if (d[(y * w + i) * 4 + 3] > 40) { r.r = (i + 1) / w; f = true; break; }
    } catch (e) {}
    return r;
  }

  /* Unterkante des Topfbilds in Buehnen-Einheiten (Topf 1000 x 538 ab 745). Hohe Toepfe (z. B. mit
     Fuessen) reichen tiefer als POT_UNTEN - dann wird die Buehne so weit verkleinert, dass der Topf
     ganz ins Bild passt. Niedrige Toepfe aendern nichts (Pflanze bleibt beim Topfwechsel gleich gross). */
  var topfCache = {};
  function topfUnten(img) {
    var k = (img.getAttribute('src') || '').split('?')[0];
    if (!(k in topfCache)) topfCache[k] = Math.round(745 + rand(img).u * 1000 * img.naturalHeight / img.naturalWidth);
    return topfCache[k];
  }

  /* Eigenschafts-Badges (Daten "badges" aus product.fgkarte), hoechstens 2 je Karte. Sie stehen in einem
     eigenen Streifen unten im Bild - die Buehne wird um dessen Hoehe nach oben gesetzt, damit kein Badge
     ueber Pflanze oder Topf liegt. */
  var BADGES = {
    kunst: ['Kunstpflanze', '<path d="M12 3l1.8 4.6L18.5 9l-4.7 1.4L12 15l-1.8-4.6L5.5 9l4.7-1.4z"/><path d="M18 15l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z"/>'],   
    best: ['Bestseller', '<path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8L3.5 9.7l5.9-.9z"/>'],
    tier: ['Tierfreundlich', '<circle cx="7" cy="10" r="1.8"/><circle cx="11" cy="6.5" r="1.8"/><circle cx="15.5" cy="7" r="1.8"/><circle cx="18.5" cy="11" r="1.8"/><path d="M8.5 17.5c0-2.6 1.9-4.8 4-4.8s4 2.2 4 4.4c0 1.6-1.2 2.4-2.6 2.1-1-.2-1.8-.2-2.8 0-1.5.4-2.6-.3-2.6-1.7z"/>'],
    luft: ['Luftreinigend', '<path d="M3 8h11a3 3 0 1 0-3-3"/><path d="M3 12h16a3 3 0 1 1-3 3"/><path d="M3 16h7"/>'],
    pflege: ['Pflegeleicht', '<path d="M5 19c0-8 5-13 14-14-1 9-6 14-14 14z"/><path d="M5 19l7-7"/>']
  };
  function badgeLeiste(liste) {
    var teile = (liste || []).filter(function (k) { return BADGES[k]; }).slice(0, 2);
    if (!teile.length) return null;
    var el = document.createElement('div'); el.className = 'fgk-eig';
    el.innerHTML = teile.map(function (k) {
      return '<span class="fgk-eig-b fgk-eig-' + k + '"><svg viewBox="0 0 24 24" aria-hidden="true">' + BADGES[k][1] + '</svg>' + BADGES[k][0] + '</span>';
    }).join('');
    return el;
  }

  function bewertung(item) {
    var b = item.querySelector('.jdgm-prev-badge');
    if (!b) return null;
    var r = parseFloat(b.getAttribute('data-average-rating')), n = parseInt(b.getAttribute('data-number-of-reviews'), 10);
    if (!(n > 0) || !(r > 0)) return null;
    return { r: r.toFixed(1).replace('.', ','), n: n };
  }

  function linksSetzen(item, vid) {
    item.querySelectorAll('a.ProductItem__ImageWrapper, .ProductItem__Title a').forEach(function (a) {
      try {
        var u = new URL(a.getAttribute('href'), location.origin);
        if (vid) u.searchParams.set('fgtopf', vid); else u.searchParams.delete('fgtopf');
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    });
  }

  /* Set-Buehne: n Glieder (je Pflanze + Topf, 1000 x 1300 Einheiten wie die Einzelbuehne).
     Groesse: die Gruppe fuellt 94 % der Hoehe, hoechstens so breit, dass die aeusseren Toepfe im Bild
     bleiben; Abstand der Pflanzen 35 % der Gliedbreite, die aeusseren auf 94 % verkleinert. */
  var SET_ABST = 0.35, SET_SEITE = 0.94, SET_VOR = 0.025;
  function setBuehne(box, P, fertig, fehler, reserve) {
    var st = document.createElement('div'); st.className = 'fgk-buehne fgk-setbuehne'; st.setAttribute('aria-hidden', 'true');
    var n = P.set.length, mitte = Math.floor(n / 2), geladen = 0, kaputt = false, bereit = false, toU = POT_UNTEN;
    var gl = P.set.map(function (g, i) {
      var d = document.createElement('div'); d.className = 'fgk-glied' + (i === mitte ? ' fgk-mitte' : '');
      var pl = new Image(); pl.className = 'fgk-pflanze'; pl.alt = ''; pl.decoding = 'async'; pl.crossOrigin = 'anonymous';
      var pt = new Image(); pt.className = 'fgk-topf'; pt.alt = ''; pt.decoding = 'async'; pt.crossOrigin = 'anonymous';
      d.appendChild(pl); d.appendChild(pt); st.appendChild(d);
      return { d: d, pl: pl, pt: pt, h: parseFloat(g.h) || 30, bild: g.bild, hg: g.hg || '', i: i, o: 0.1, f: 1 };
    });
    box.appendChild(st);
    function passe() {
      if (!bereit) return;
      var W = box.clientWidth, H = box.clientHeight - reserve(); if (!W || !H) return;
      var oben = 835;                                             /* hoechste Blattspitze in Einheiten */
      gl.forEach(function (g) { oben = Math.min(oben, 835 * (1 - g.f * (1 - g.o))); });
      var unten = Math.max(POT_UNTEN, toU) + 1300 * SET_VOR;      /* mittlerer Topf steht etwas tiefer */
      var hu = unten - oben + 60;
      var gw = Math.min(H * 0.94 * 1000 / hu, W * 0.46 / ((n - 1) / 2 * SET_ABST + 0.2), W * 1.2);
      var u = gw / 1000, frei = Math.max(0, H * 0.94 - hu * u) / 2;
      var top = H - (unten + 24) * u - frei;                      /* Gruppe in der Hoehe mittig */
      gl.forEach(function (g) {
        g.d.style.width = gw + 'px';
        g.d.style.left = (W / 2 + (g.i - (n - 1) / 2) * SET_ABST * gw - gw / 2) + 'px';
        g.d.style.top = top + 'px';
      });
    }
    function los() {
      gl.forEach(function (g) { g.s = g.h / Math.max(0.2, 1 - g.o); });
      var max = Math.max.apply(null, gl.map(function (g) { return g.s; }));
      gl.forEach(function (g) { g.f = g.s / max; g.pl.style.transform = 'scale(' + g.f.toFixed(3) + ')'; });
      bereit = true; passe(); fertig();
    }
    gl.forEach(function (g) {
      /* Ueberhang je Pflanze (hg = hohes Bild 1000 x 1355, Basis bei 835) wie bei der Einzelkarte.
         Oberkante o immer auf die 835er-Einheiten umrechnen; Skalierung vom Topfrand aus (61,6 %). */
      g.pl.onload = function () {
        if (kaputt) return;
        var ph = 1000 * g.pl.naturalHeight / g.pl.naturalWidth;
        g.o = rand(g.pl).o * ph / 835;
        if (ph > 900) g.pl.style.transformOrigin = '50% ' + (83500 / ph).toFixed(2) + '%';
        if (++geladen === n) los();
      };
      g.pl.onerror = function () {
        if (g.hg) { g.hg = ''; g.pl.src = g.bild; return; }   /* hohe Datei fehlt -> normales Bild */
        if (!kaputt) { kaputt = true; fehler(); }
      };
      g.pl.src = g.hg || g.bild;
    });
    if (window.ResizeObserver) new ResizeObserver(passe).observe(box); else window.addEventListener('resize', passe);
    gl[0].pt.onload = function () { toU = topfUnten(gl[0].pt) + 10; passe(); };
    return { el: st, topf: function (url) { gl.forEach(function (g) { g.pt.src = url; }); } };
  }

  function istFuesse(t) { return /F(ü|ue)(ß|ss)en|Feet/i.test((t.t || '') + ' ' + (t.n || '')); }
  function rasterPos(item) {
    var g = item.closest('.boost-pfs-filter-products, .ProductList');
    if (!g) return 0;
    var alle = g.querySelectorAll('.ProductItem');
    return Math.max(0, Array.prototype.indexOf.call(alle, item));
  }
  /* Vorfuehr-Karten - auf hoechstens DEMO_MAX Pflanzenkarten je Seite wechselt der Topf von selbst
     (alle DEMO_TAKT ms, dauerhaft), damit man sieht, dass die Toepfe waehlbar sind. Mindestabstand
     DEMO_ABSTAND Positionen im Raster (Topfkarten auf gemischten Seiten zaehlen mit). Durchlauf ueber alle
     sichtbaren Toepfe inkl. Fuesse und Elho; "Ohne Topf" gehoert nicht dazu. Pausiert bei Hover/Beruehrung und ausserhalb des
     Bildes, endet endgueltig, sobald der Kunde selbst einen Topf waehlt. Kein Auto-Wechsel bei
     "Bewegung reduzieren" (prefers-reduced-motion) und nicht bei Sets. */
  var DEMO_MAX = 3, DEMO_ABSTAND = 5, DEMO_TAKT = 2600;
  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function demoErlaubt(item, pos) {
    if (ruhig || !window.IntersectionObserver) return false;
    var g = item.closest('.boost-pfs-filter-products, .ProductList'); if (!g) return false;
    if (g.classList.contains('ProductList--carousel')) return false;   /* keine Vorfuehrung in Karussells (z.B. "Zuletzt angesehen") */
    if (document.querySelectorAll('.ProductItem.fgk-demo').length >= DEMO_MAX) return false;   /* je Seite */
    var demos = g.querySelectorAll('.ProductItem.fgk-demo');
    for (var i = 0; i < demos.length; i++) if (Math.abs(rasterPos(demos[i]) - pos) < DEMO_ABSTAND) return false;
    return true;
  }

  function baue(item, P, T) {
    var wrap = item.querySelector('a.ProductItem__ImageWrapper');
    var box = wrap && wrap.querySelector('.AspectRatio');
    var info = item.querySelector('.ProductItem__Info');
    if (!wrap || !box || !info) { item.classList.add('fgk-aus'); return; }

    /* Toepfe sortieren: Kollektionsreihenfolge, Kunststoff (Elho) ans Ende */
    var toepfe = T.filter(function (t) { return !t.elho; }).concat(T.filter(function (t) { return t.elho; }));
    if (!toepfe.length) { item.classList.add('fgk-aus'); return; }

    item.classList.add('fgk-karte');
    /* Grauer Grund nur hinter der Buehne - blendet beim Hover mit ihr aus, damit das zweite Bild
       (Fotos mit anderem Seitenverhaeltnis, object-fit: contain) keinen grauen Rand bekommt */
    var grund = document.createElement('div'); grund.className = 'fgk-grund'; grund.setAttribute('aria-hidden', 'true');
    box.appendChild(grund);
    var eig = badgeLeiste(P.badges);
    if (eig) box.appendChild(eig);
    function reserve() { return eig ? eig.offsetHeight + 14 : 0; }   /* Streifen fuer die Badges unten im Bild */

    /* 1) Buehne */
    var istSet = P.set && P.set.length > 1, sb = null;
    var anz = istSet ? P.set.length : 1;
    var st, pl, pt = { set src(u) { if (sb) sb.topf(u); } };
    if (istSet) {
      sb = setBuehne(box, P, function () { item.classList.add('fgk-bereit'); item.classList.remove('fgk-aus'); }, function () { abbauen(); }, reserve);
      st = sb.el;
    } else {
    st = document.createElement('div'); st.className = 'fgk-buehne'; st.setAttribute('aria-hidden', 'true');
    pl = new Image(); pl.className = 'fgk-pflanze'; pl.alt = ''; pl.decoding = 'async'; pl.crossOrigin = 'anonymous';
    pt = new Image(); pt.className = 'fgk-topf'; pt.alt = ''; pt.decoding = 'async'; pt.crossOrigin = 'anonymous';
    st.appendChild(pl); st.appendChild(pt); box.appendChild(st);
    /* Pflanzenbild 1000 x 835 (normal) bzw. 1000 x 1355 (haengend/Ueberhang), oben buendig;
       der Topf beginnt immer bei 745 Einheiten (= Konfigurator: -9 % bzw. -61 % Ueberlappung) */
    var o = 0.1, unten = POT_UNTEN, ph = 835, plU = POT_UNTEN, toU = POT_UNTEN, halb = 0.5;
    function passe() {
      var W = box.clientWidth, H = box.clientHeight - reserve(); if (!W || !H) return;
      var h = unten - o * ph + 60;                             /* sichtbarer Inhalt in Einheiten */
      var s = Math.min(H * 0.94 / (h * W / 1000), 1.35, 0.485 / halb);   /* breite Pflanzen seitlich nicht abschneiden */
      st.style.width = (100 * s) + '%';
      st.style.top = (H - (unten + 24) * W * s / 1000) + 'px';
    }
    var hoch = !!P.hoch;
    pl.onload = function () {
      ph = Math.round(1000 * pl.naturalHeight / pl.naturalWidth);
      var r = rand(pl); o = r.o; halb = Math.max(0.3, 0.5 - r.l, r.r - 0.5);
      plU = Math.round(r.u * ph) + 10;
      unten = Math.max(POT_UNTEN, plU, toU);
      passe(); item.classList.add('fgk-bereit'); item.classList.remove('fgk-aus');
    };
    pt.onerror = function () { pt.style.opacity = ''; };
    pt.onload = function () {
      pt.style.opacity = '';
      toU = topfUnten(pt) + 10;
      unten = Math.max(POT_UNTEN, plU, toU); passe();
    };
    pl.onerror = function () {
      if (hoch) { hoch = false; pl.src = passendeBreite(P.bild, box); return; }   /* hohe Datei fehlt -> normales Bild */
      abbauen();
    };
    pl.src = passendeBreite(hoch ? P.hoch : P.bild, box);
    if (window.ResizeObserver) new ResizeObserver(passe).observe(box); else window.addEventListener('resize', passe);
    }

    function abbauen() {
      item.classList.remove('fgk-karte', 'fgk-bereit', 'fgk-kompakt'); item.classList.add('fgk-aus');
      [grund, eig, st, sw, meta, zeile].forEach(function (el) { if (el && el.parentNode) el.parentNode.removeChild(el); });
      linksSetzen(item, null);
    }

    /* 2) Topfwahl */
    var sw = document.createElement('div'); sw.className = 'fgk-toepfe'; sw.setAttribute('role', 'radiogroup'); sw.setAttribute('aria-label', 'Topf wählen');
    var mobil = window.matchMedia('(max-width: 640px)').matches;
    /* (2): sichtbare Toepfe = klassische Toepfe + (falls vorhanden) ein Elho-Topf; dahinter "Ohne Topf"
       (gleiche Gesamtzahl Knoepfe wie bisher, damit die Zeile nicht umbricht) */
    var plaetze = (mobil ? MAX_MOBIL : MAX_DESKTOP) - (P.ohne && P.ohne.img ? 1 : 0);
    var klassik = toepfe.filter(function (t) { return !t.elho; }), elhoT = toepfe.filter(function (t) { return t.elho; });
    var zeigen = klassik.slice(0, elhoT.length ? plaetze - 1 : plaetze).concat(elhoT).slice(0, plaetze);
    /* (3): Start-Topf wieder wie vorher = erster Topf der Kollektion (Patt bzw. Charlie Grau),
       damit die Seite ruhig bleibt. Vorfuehr-Karten bekommen zusaetzlich einen Topf mit Fuessen in die
       Knoepfe (ersetzt den letzten klassischen Platz), damit der Wechsel auffaelliger ist. */
    var pos = rasterPos(item);
    var demo = !istSet && demoErlaubt(item, pos);
    var fuesseT = klassik.filter(istFuesse);
    if (demo && fuesseT.length && !zeigen.some(istFuesse)) {
      var fz = fuesseT[document.querySelectorAll('.ProductItem.fgk-demo').length % fuesseT.length];
      var nKl = zeigen.filter(function (t) { return !t.elho; }).length;
      if (zeigen.length < plaetze) zeigen.splice(nKl, 0, fz);   /* Platz frei: hinter die klassischen Toepfe */
      else if (nKl > 1) zeigen[nKl - 1] = fz;                   /* sonst letzten klassischen Platz tauschen */
    }
    var sel = 0;
    var knoepfe = zeigen.slice();
    if (P.ohne && P.ohne.img) knoepfe.push({ ohne: true, img: P.ohne.img, sw: P.ohne.sw, t: '', n: 'Ohne Topf' });
    knoepfe.forEach(function (t, i) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'fgk-topfknopf';
      b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', i === sel ? 'true' : 'false');
      var name = kurzname(t); b.title = name; b.setAttribute('aria-label', name);
      if (t.ohne) b.className += ' fgk-ohne';
      b.innerHTML = '<img src="' + esc(t.sw) + '" alt="" loading="lazy" width="48" height="48">';
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        demoStopp();
        sel = i; sw.querySelectorAll('.fgk-topfknopf').forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        b.setAttribute('aria-checked', 'true'); setze(true);
      });
      sw.appendChild(b);
    });
    var rest = toepfe.length - zeigen.length;
    if (rest > 0) {
      var m = document.createElement('a'); m.className = 'fgk-mehr'; m.href = wrap.getAttribute('href').split('?')[0];
      m.textContent = '+' + rest + ' weitere'; sw.appendChild(m);
    }
    wrap.parentNode.insertBefore(sw, wrap.nextSibling);

    /* 3) Kompakte Zeile Ø · Hoehe · Bewertung (ersetzt Chips + Sternezeile in dieser Karte) */
    var vals = item.querySelectorAll('[data-plant-size-meta] .PlantSizeMeta__Value');
    var d = vals[0] ? vals[0].textContent.replace(/[^\d,.]/g, '') : '';
    var hh = vals[1] ? vals[1].textContent.replace(/[^\d,.]/g, '') : '';
    var bw = bewertung(item);
    var meta = document.createElement('div'); meta.className = 'fgk-meta';
    var teile = [];
    if (istSet) { teile.push(anz + ' Pflanzen'); if (P.oe) teile.push('Ø ' + P.oe + ' cm'); }
    if (d && !istSet) teile.push('Ø ' + d + ' cm'); if (hh) teile.push(hh + ' cm hoch');   /* Set - Ø nur einmal (aus P.oe) */
    meta.innerHTML = '<span>' + esc(teile.join(' · ')) + '</span>' + (bw ? '<span class="fgk-sterne"><span aria-hidden="true">★</span> ' + bw.r + ' <span class="fgk-anz">(' + bw.n + ')</span></span>' : '');
    var titel = info.querySelector('.ProductItem__Title');
    if (titel && titel.parentNode) titel.parentNode.insertBefore(meta, titel.nextSibling); else info.appendChild(meta);
    item.classList.add('fgk-kompakt');

    /* 4) Topfzeile unter dem Preis */
    var zeile = document.createElement('div'); zeile.className = 'fgk-topfzeile';
    var preisliste = info.querySelectorAll('.ProductItem__PriceList');
    var nach = preisliste.length ? preisliste[preisliste.length - 1] : null;
    if (nach && nach.parentNode) nach.parentNode.insertBefore(zeile, nach.nextSibling); else info.appendChild(zeile);

    function setze(gewaehlt, weich) {
      var t = knoepfe[sel];
      if (weich && !istSet && pt.getAttribute('src') !== t.img) {   /* Vorfuehrung: Topf kurz ausblenden, neuen einblenden */
        pt.style.opacity = '0';
        setTimeout(function () { pt.src = t.img; }, 220);
      } else pt.src = t.img;
      if (t.ohne) {   /* nur die Pflanze im Kulturtopf - keine Vorauswahl auf der Produktseite */
        zeile.innerHTML = '<b>Ohne Topf</b>' + (anz > 1 ? ' · ' + anz + ' Pflanzen im Kulturtopf' : ' · im Kulturtopf');
        linksSetzen(item, null); return;
      }
      var txt = (anz > 1 ? '+ ' + anz + ' × Topf <b>' : '+ Topf <b>') + esc(kurzname(t)) + '</b>';
      if (!P.b2b) {
        txt += (anz > 1 ? ' je ' : ' ') + geld(t.pr);
        if (!P.vielePreise && P.preis > 0) txt += ' · zusammen ' + geld(P.preis + anz * t.pr);
      }
      zeile.innerHTML = txt;
      linksSetzen(item, gewaehlt ? t.v : null);   /* Vorauswahl nur, wenn der Kunde selbst gewaehlt hat */
    }
    setze(false);

    /* Vorfuehr-Karte */
    var demoT = null, demoAus = true;
    function demoStopp() { demoAus = true; clearInterval(demoT); demoT = null; item.classList.remove('fgk-demo-laeuft'); }
    if (demo) {
      var folge = [];
      zeigen.forEach(function (t, i) { folge.push(i); });   /* alle sichtbaren Toepfe inkl. Fuesse/Elho, ohne "Ohne Topf" */
      if (folge.length > 2) {
        item.classList.add('fgk-demo'); demoAus = false;
        var schritt = 0, sichtbar = false, pause = false;
        var start = folge.indexOf(sel);
        var weiter = function () {
          if (demoAus || !sichtbar || pause || document.hidden) return;
          schritt++;
          sel = folge[(start + schritt) % folge.length]; markiere(); setze(false, true);
        };
        var lauf = function () {
          if (demoAus) return;
          clearInterval(demoT); demoT = null; item.classList.remove('fgk-demo-laeuft');
          if (sichtbar && !pause) { demoT = setInterval(weiter, DEMO_TAKT); item.classList.add('fgk-demo-laeuft'); }
        };
        new IntersectionObserver(function (e) { sichtbar = e[0].isIntersecting; lauf(); }, { threshold: 0.6 }).observe(box);
        item.addEventListener('mouseenter', function () { pause = true; lauf(); });
        item.addEventListener('mouseleave', function () { pause = false; lauf(); });
        item.addEventListener('touchstart', demoStopp, { passive: true });
      }
    }
    function markiere() {
      sw.querySelectorAll('.fgk-topfknopf').forEach(function (x, i) { x.setAttribute('aria-checked', i === sel ? 'true' : 'false'); });
    }
  }

  /* Ladezeit: das Pflanzenbild startet, sobald die Pflanzendaten da sind - parallel zur
     Topfliste statt danach. Gleiche URL und gleicher CORS-Modus wie das Buehnenbild, damit der Browser
     die Datei wiederverwendet. Karten im ersten sichtbaren Bereich laden mit hoher Prioritaet. */
  var vorgeladen = {};
  function vorladen(url, hoch) {
    if (!url || vorgeladen[url]) return; vorgeladen[url] = true;
    var i = new Image(); i.crossOrigin = 'anonymous'; i.decoding = 'async';
    if (hoch) try { i.fetchPriority = 'high'; } catch (e) {}
    i.src = url;
  }

  function verarbeite(item) {
    if (item.__fgk) return; item.__fgk = true;
    function aus() { if (!item.classList.contains('fgk-bereit')) item.classList.add('fgk-aus'); }
    var h = handleVon(item); if (!h) { aus(); return; }
    setTimeout(aus, WARTEN);
    /* nur Pflanzen (Ø/Hoehe-Chips) und Pflanzen-Sets (haben keine Chips) */
    if (!item.querySelector('[data-plant-size-meta]')) {
      var tt = item.querySelector('.ProductItem__Title');
      if (!SET_RE.test(h + ' ' + (tt ? tt.textContent : ''))) return;
    }
    holeJSON('/products/' + encodeURIComponent(h) + '?view=fgkarte', cacheP, 'p:' + h).then(function (P) {
      if (!P || P.ok !== 1 || !P.oe || !P.bild) { aus(); return; }
      var box = item.querySelector('a.ProductItem__ImageWrapper .AspectRatio');
      var vorn = item.getBoundingClientRect().top < (window.innerHeight || 800);
      if (P.set && P.set.length > 1) P.set.forEach(function (g) { vorladen(g.hg || g.bild, vorn); });
      else if (box) vorladen(passendeBreite(P.hoch || P.bild, box), vorn);
      return holeJSON('/collections/konfigurator-oe-' + encodeURIComponent(P.oe) + '?view=fgtopf', cacheT, 't:' + P.oe).then(function (T) {
        if (T && T.toepfe && T.toepfe.length) baue(item, P, T.toepfe); else aus();
      });
    }).catch(aus);   /* Karte bleibt unveraendert */
  }

  /* Karten weiter unten erst bearbeiten, wenn sie in die Naehe des sichtbaren Bereichs kommen (600 px
     Vorlauf) - so konkurrieren sie nicht mit der ersten Reihe um die Leitung. Ohne IntersectionObserver
     werden alle sofort bearbeitet. */
  var beobachter = window.IntersectionObserver ? new IntersectionObserver(function (eintraege) {
    eintraege.forEach(function (e) { if (e.isIntersecting) { beobachter.unobserve(e.target); verarbeite(e.target); } });
  }, { rootMargin: '600px 0px' }) : null;
  /* alle Produktkarten der Seite (Kollektion, Suche, Such-Fenster, Startseite, Empfehlungen) -
     vorher nur Kollektionsraster; Karten anderswo blieben wegen des grauen Platzhalters (CSS .fgk-js) leer. */
  /* FG 29.10.2026: Bewertung auf Produktkarten ausserhalb unserer Kollektionsseiten (Such-Fenster, Empfehlungen,
     Karussells) kompakt wie dort: "★ 4,8 (54)" statt fuenf Sterne + "34 Bewertungen". Ohne Bewertungen entfaellt die
     Zeile. Kollektionskarten (#fgc) bauen das in assets/fg-collection.js selbst. */
  function kurzBewertung(item) {
    if (item.__fgkRt || (item.closest && item.closest('#fgc'))) return;
    var box = item.querySelector('.ProductItem__Rating'); if (!box) return;
    var b = box.querySelector('.jdgm-prev-badge'); if (!b) return;
    item.__fgkRt = true;
    var n = parseInt(b.getAttribute('data-number-of-reviews'), 10) || 0;
    if (!n) { box.classList.add('fgk-rt-leer'); return; }
    var avg = (parseFloat(b.getAttribute('data-average-rating')) || 0).toFixed(1).replace('.', ',');
    var s = document.createElement('span'); s.className = 'fgk-rt'; s.title = avg + ' von 5 Sternen, ' + n + ' Bewertungen';
    s.innerHTML = '<b aria-hidden="true">★</b> ' + avg + ' <span>(' + n + ')</span>';
    box.classList.add('fgk-rt-box'); box.appendChild(s);
  }
  function alle(root) {
    (root || document).querySelectorAll('.ProductItem').forEach(function (item) {
      kurzBewertung(item);
      if (item.__fgk || item.__fgkBeob) return;
      if (beobachter) { item.__fgkBeob = true; beobachter.observe(item); } else verarbeite(item);
    });
  }

  function start() {
    alle();
    /* Nachgeladene Karten (Boost-Raster nach Filter/Sortierung, Such-Fenster, Produktempfehlungen,
       Karussells): ein Beobachter fuer die ganze Seite. Reagiert nur, wenn wirklich eine Produktkarte
       eingefuegt wurde - Text-Aenderungen (z. B. Countdown) kosten nur die kurze Pruefung. */
    if (window.MutationObserver) {
      var t;
      new MutationObserver(function (ml) {
        for (var i = 0; i < ml.length; i++) {
          var an = ml[i].addedNodes;
          for (var j = 0; j < an.length; j++) {
            var n = an[j];
            if (n.nodeType === 1 && (n.classList.contains('ProductItem') || n.querySelector('.ProductItem'))) {
              clearTimeout(t); t = setTimeout(alle, 60); return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
